/* global angular, d3, d3plus, _ */

var ngModule = angular.module('trends');
var $ = jQuery;
var cache = {};

ngModule.directive('trendscapeHover', [ '$compile', function($compile) {
    return {
        restrict: 'A',
        scope: true,
        link: function(scope, element) {
            var datatype = scope.data.type;
            if (datatype === 'demographic' || datatype === 'driver' || datatype === 'sector') {
                datatype = 'hvt';
            } else if (datatype === 'search_keyword') {
                datatype = 'search';
            }

            if (!cache[datatype]) {
                jQuery.ajax({
                    'url': '/trends/partials/trendscape_hover/' + datatype + '/',
                    'success': function(html) {
                        scope.$apply(function() {
                            element.append($compile(html)(scope));
                            cache[datatype] = html;
                        });
                    }
                });
            } else {
                scope.$apply(function() {
                    element.append($compile(cache[datatype])(scope));
                });
            }
        }
    };
}]);

ngModule.directive('trendscape', [ '$compile', 'Api', 'QuerySerializer', '$state', 'HistoricContext', '$alert',
    function($compile, Api, QuerySerializer, $state, HistoricContext, $alert) {

    return {
        restrict: 'A',
        scope: true,
        link: function(scope, element, attrs) {
            // Seed random number generator to give consistent values
            Math.seedrandom('trendscape');


            /** Global variables **/

            // Item type filters selectable by the user via checkboxes in the key/legend
            scope.filters = ['trend', 'observation', 'pillar', 'driver', 'demographic', 'sector', 'search'];

            var width = $(window).width() - 250, height = 600, // SVG size
                data, // data loaded from API
                mode = attrs.trendscapeMode, // trendscape mode (item or search)
                itemId = mode === 'item' ? attrs.trendscapeQuery : null, // item ID
                itemType = mode === 'item' ? attrs.trendscapeItemType : null, // item type
                itemName, // unique name of central node
                searchTerm, searchFilters, // search parameters
                nodes, // D3 selector for g elements representing nodes
                nextCentreNode, // the next node to become the central focus
                nodeBeingDragged = false, // track whether a node is being dragged manually
                nodeClicked = false, // track whether data load was triggered by clicking on a node
                tooltipOpen = false, // track whether the tooltip is open
                tooltipId, // track the id of the item shown in the tooltip
                selectedNode, // track the node most recently clicked by the user
                loaded = false,
                frozenNodes; // track which nodes have been frozen;

            // Alert when something goes wrong when loading the trendscape
            var alert_content = {
                title: 'Trendscape Error',
                type: 'danger',
                container: '#trendscape',
                placement: 'alert-error',
                dismissable: true,
                show: false,
            };


            /** Get data from the API **/

            /* Function triggered when data is returned */
            var dataLoaded = function(response) {
                scope.dataReady = true;
                loaded = false;

                // Animate moving the clicked node into the centre
                if (nextCentreNode) {
                    d3.selectAll('line').remove();
                    var n = d3.select(nextCentreNode);
                    n.transition().attr('transform', 'translate(' + width/2 + ',' + height/2 + ')');
                }

                // Wait until transition has finished to display new data
                window.setTimeout(function() {
                    scope.$apply(function() {
                        data = response.plain();

                        // store unique name of central node
                        data.nodes.forEach(function(n) {
                            n.centralNode = false;
                            if (scope.isCentralNode(n)) {
                                itemName = n.unique_name;
                                n.centralNode = true;
                                document.title = 'Trendscape - ' + n.title;
                            }
                        });

                        updateData();
                        updateDisplay();
                        loaded = true;
                    });
                }, 250);

                // update the ppt_section to reflect the new content
                if (mode === 'search') {
                    scope.current_ppt_section = 'trendscape-search-0';
                } else {
                    scope.current_ppt_section = 'trendscape-' + itemType + '-' + itemId;
                }

                // If data load was triggered by clicking on a node, update the URL and add to browser history
                if (nodeClicked) {
                    $state.go('trendscape-item', {item_type: itemType, item_id: itemId}, {notify: false});
                }
            };

            /* Function triggered if the API request fails */
            var dataNotLoaded = function() {
                var failure = nodeClicked ? 'updating' : 'creating';
                angular.extend(alert_content, {
                    content: 'Sorry, there was a problem ' + failure + ' the Trendscape, please try again. <br>' +
                        'We will resolve persistent issues as soon as possible. ' +
                        'If it\'s urgent, please contact your account manager.'
                });
                var alrt = $alert(alert_content);
                scope.dataReady = true;
                alrt.$promise.then(alrt.show);
            };

            /* Serialize the search parameters */
            var serializer = new QuerySerializer({
                filters: { type: 'object', required: false },
                q: { type: 'string', required: false }
            });

            /* Load data from the API */
            if (mode === 'item') {
                Api.trendscape[itemType].get({ 'id': itemId }).then(dataLoaded, dataNotLoaded);
            } else if (mode === 'search') {
                var params = serializer.load();
                searchTerm = params.q;
                searchFilters = params.filters;
                Api.trendscape.search.get({ 'q': params.q , 'filters': params.filters})
                    .then(dataLoaded, dataNotLoaded);
            }


            /** Create SVG area **/

            var svg, defs, filter, linkGroup, nodeGroup, blurFilter, blur, darkenFilter, darken, pattern, patternImage,
                desaturateFilter, desaturate;

            /* Slightly hacky: delay svg creation until after the digest cycle so
               it doesn't break when going back via the browser back button */
            window.setTimeout(function() {
                // Remove the SVG if it's been preserved by the browser navigation
                $('.trendscape-container svg').remove();

                // When width is initially set the page hasn't always finished loading, so re-set it here
                width = $(window).width() - 250;

                svg = d3.select('#trendscape').append('svg')
                    .attr('height', height)
                    .attr('width', width);
                defs = svg.append('defs');

                // Add drop shadow behind nodes
                filter = defs.append('filter')
                    .attr('id', 'shadow')
                    .attr('height', '120%');
                filter.append('feOffset')
                    .attr('result', 'offOut')
                    .attr('in', 'SourceAlpha')
                    .attr('dx', 0.2)
                    .attr('dy', 0.2);
                filter.append('feGaussianBlur')
                    .attr('in', 'offOut')
                    .attr('stdDeviation', 2)
                    .attr('result', 'blurOut');
                filter.append('feBlend')
                    .attr('in', 'SourceGraphic')
                    .attr('in2', 'blurOut')
                    .attr('mode', 'normal');

                // Add blur filter (applied to nodes not relevant to node being moused over)
                blurFilter = defs.append('filter')
                    .attr('id', 'blur');
                blur = blurFilter.append('feGaussianBlur')
                    .attr('in', 'SourceGraphic')
                    .attr('stdDeviation', 1);

                // Add filter to darken SVG image
                darkenFilter = defs.append('filter')
                    .attr('id', 'darken');
                darken = darkenFilter.append('feColorMatrix')
                    .attr('type', 'matrix')
                    .attr('values',
                        '0.5 0   0   0   0 ' + // R - 50%
                        '0   0.5 0   0   0 ' + // G - 50%
                        '0   0   0.5 0   0 ' + // B - 50%
                        '0   0   0   1   0'    // Alpha - 100%
                    );

                // Add background image pattern for the central node
                pattern = defs.append('pattern')
                    .attr('id', 'centre-image')
                    .attr('width', 1)
                    .attr('height', 1)
                    .attr('viewBox', '0 0 200 200');
                patternImage = pattern.append('image')
                    .attr('width', 200)
                    .attr('height', 200)
                    .attr('preserveAspectRatio', 'xMidYMid slice')
                    .attr('filter', 'url("#darken")');

                // Add filter to desaturate nodes
                desaturateFilter = defs.append('filter')
                    .attr('id', 'desaturate');
                desaturate =  desaturateFilter.append('feColorMatrix')
                    .attr('type', 'matrix')
                    .attr('values',
                        '0.3 0.3 0.3 0   0 ' + // R
                        '0.3 0.3 0.3 0   0 ' + // G
                        '0.3 0.3 0.3 0   0 ' + // B
                        '0   0   0   1   0'    // Alpha - 100%
                    );

                // Add groups for SVG elements
                linkGroup = svg.append('g')
                    .attr('id', 'links');
                nodeGroup = svg.append('g')
                    .attr('id', 'nodes');
            }, 0);


            /** Physics **/

            // Try to prevent nodes overlapping each other
            function collide(node, alpha) {
                var r = node.radius,
                    nx1 = node.x - r,
                    nx2 = node.x + r,
                    ny1 = node.y - r,
                    ny2 = node.y + r;
                return function(quad, x1, y1, x2, y2) {
                    if (quad.point && (quad.point !== node)) {
                        var x = node.x - quad.point.x,
                        y = node.y - quad.point.y,
                        l = Math.sqrt(x * x + y * y),
                        r = node.radius + quad.point.radius;
                        if (l < r) {
                            l = (l - r) / l * alpha;
                            if (!node.fixed) {
                                node.x -= x * l;
                                node.y -= y * l;
                            }
                            if (!quad.point.fixed) {
                                quad.point.x += x * l;
                                quad.point.y += y * l;
                            }
                        }
                    }
                    return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
                };
            }

            // Define force for force-directed layout
            var force = d3.layout.force()
                .gravity(0.01)
                .charge(function(d) { return scope.isCentralNode(d) ? -10000 : -250; })
                .linkDistance(function(l) { return l.length; })
                .size([width,height]);

            // Track when a node is being dragged by the user
            var drag = force.drag()
                .on('dragstart', function() { nodeBeingDragged = true; })
                .on('dragend', function() {
                    nodeBeingDragged = false;

                    // Now save positions in session storage
                    var nodePositions = [];
                    getRelevantNodes().forEach(function(d) {
                        nodePositions.push({ unique_name: d.unique_name, x: d.x, y: d.y });
                    });
                    HistoricContext.insert(getKeyFromParams('positions'), nodePositions, 'session');
                    HistoricContext.save();
                });

            /** Display functions **/

            $('.d3-tip').remove();
            var tooltip = d3.tip()
                .attr('class', 'd3-tip')
                .html(function() {
                    return '<span id="tip-tour-stop">' +
                                '<div id="trendscape-hover-container" data-trendscape-hover></div>' +
                            '</span>';
                });

            /* Update the d3 trendscape visualisation */
            var updateDisplay = function() {
                // Bind data and create svg groups for each node
                nodes = nodeGroup.selectAll('.g')
                    .data(getRelevantNodes(), function(d) { return d.unique_name; });
                nodes.enter()
                    .append('g')
                    .attr('class', 'g')
                    .attr('id', function(d) {
                        if (d.centralNode) {
                            return 'central-node';
                        }
                        return '';
                    })
                    .on('mouseout', mouseout)
                    .on('mouseover', mouseover)
                    .on('click', nodeclick)
                    .on('contextmenu', rightclick)
                    .attr('transform', 'translate(' +  width/2 + ',' + height/2 + ')')
                    .call(drag);
                nodes.exit().remove();
                nodes.call(tooltip)
                    .classed('fixed', function(d) {
                        d.fixed = scope.isCentralNode(d);
                    });

                // For nodes that existed previously, remove child elements before recreating them
                nodes.selectAll('*').remove();

                // Draw circles for each node
                nodes.append('circle')
                    .attr('r', function(d) {
                        // Set circle size
                        d.radius = scope.isCentralNode(d) ? 100 : 30 + (10 * d.size);
                        return d.radius;
                    })
                    .attr('class', function(d) { return d.type; })
                    .style('filter', 'url(#shadow)')
                    .style('fill', function(d) {
                        if (scope.isCentralNode(d) && mode === 'item') {
                            patternImage.attr('xlink:href', d.image_url);
                            return 'url(#centre-image)';
                        } else if (scope.isCentralNode(d) && mode === 'search') {
                            return '#ed5caa';
                        } else {
                            return '';
                        }
                    });

                // Add text to each node
                nodes.append('text')
                    .text(function(d) { return d.title; })
                    .attr('class', function(d) { return d.type; })
                    .classed('h3', function(d) { return scope.isCentralNode(d); })
                    .each(function() {
                        d3plus.textwrap().container(d3.select(this)).valign('middle').draw();
                    });

                // It helps with the tour if the tooltip is ready to display
                var centralNode = nodes.filter('#central-node');
                tooltip.show(centralNode.data(), centralNode.node());
                tooltip.hide();

                // Create links between nodes to pull related nodes closer together
                var links = [];
                data.links.filter(function(l) {
                    return (l.source !== itemName || l.target !== itemName) && l.is_default;
                }).forEach(function(l) {
                    var nodes = getRelevantNodes();
                    var src = nodes.filter(function(d) { return d.unique_name === l.source; })[0];
                    var tar = nodes.filter(function(d) { return d.unique_name === l.target; })[0];

                    if (src && tar) {
                        links.push({ source: src, target: tar, length: 150 });
                    }
                });

                // Create links between each node and the centre to push less relevant nodes further out
                getRelevantNodes().filter(function(n) {
                    return n.unique_name !== itemName;
                }).forEach(function(d) {
                    var src = getRelevantNodes().filter(function(n) { return scope.isCentralNode(n); })[0];
                    var tar = d;

                    links.push({ source: src, target: tar, length: d.relevance * 150 });
                });

                svg.selectAll('.g').each(function(d) {
                    // Initially position nodes in the centre
                    d.x = width/2;
                    d.y = height/2;
                });

                // Use the force, Luke
                force.nodes(getRelevantNodes())
                    .links(links)
                    .on('tick', function() {
                        // Constrain node positions to within the SVG area
                        nodes.each(function(d) {
                            var padding = 2,
                                xMin = d.radius + padding,
                                xMax = width - (d.radius + padding),
                                yMin = d.radius + padding,
                                yMax = height - (d.radius + padding);

                            if (d.x < xMin || d.x > xMax || d.y < yMin || d.y > yMax) {
                                d.x = Math.min(Math.max(xMin, d.x), xMax);
                                d.px = Math.min(Math.max(xMin, d.x), xMax);
                                d.y = Math.min(Math.max(yMin, d.y), yMax);
                                d.py = Math.min(Math.max(yMin, d.y), yMax);
                            }

                            /* Slightly hacky: in some uncommon circumstances, D3 force unfortunately
                               sets the positions to NaN and breaks. So in this case, just set the position
                               randomly and let the collision avoidance take care of the rest. */
                            if (isNaN(d.x) || isNaN(d.y)) {
                                var x = Math.random() * xMax;
                                var y = Math.random() * yMax;
                                d.x = x;
                                d.px = x;
                                d.y = y;
                                d.py = y;
                            }
                        });

                        // If a node is being dragged by the user, update its position each tick
                        if (nodeBeingDragged) {
                            nodes.attr('transform', translate);

                            d3.selectAll('line')
                                .attr('x1', function(d) { return d.source.x; })
                                .attr('y1', function(d) { return d.source.y; })
                                .attr('x2', function(d) { return d.target.x; })
                                .attr('y2', function(d) { return d.target.y; });
                        }
                    });

                // With all of the d3 components initialised, run the force simulation
                animate();

                // If any nodes were frozen previously, re-freeze them here
                if (frozenNodes.length > 0) {
                    data.nodes.forEach(function(d) {
                        if (_.contains(frozenNodes, d.unique_name)) {
                            rightclick(d);
                        }
                    });
                }
            };

            /* Perform physics, calculate node positions and then transition into position */
            var animate = function() {
                // If node positions stored in session storage, get them
                var nodePositions = HistoricContext.get().session[getKeyFromParams('positions')];
                if (nodePositions) {
                    data.nodes.forEach(function(d) {
                        var position = nodePositions.filter(function(p) { return p.unique_name === d.unique_name; })[0];
                        if (position) {
                            d.x = position.x;
                            d.y = position.y;
                            d.fixed = true;
                        }
                    });
                }

                // Calculate node positions (only applies to those that don't already have a position)
                force.start();
                var i = 0;
                while ((force.alpha() > 1e-2) && (i < 250)) {
                    force.tick();
                    i++;

                    var filteredNodes = getRelevantNodes();
                    var quad = d3.geom.quadtree(filteredNodes);
                    var j = 0, n = filteredNodes.length;
                    while (++j < n) { quad.visit(collide(filteredNodes[j], 1)); }
                }

                // Now save changed positions in session storage
                if (nodePositions) {
                    var filteredNodes = getRelevantNodes();
                    nodePositions = nodePositions.filter(function(d) {
                        return!_.contains(filteredNodes, d);
                    });
                } else {
                    nodePositions = [];
                }
                getRelevantNodes().forEach(function(d) {
                    nodePositions.push({ unique_name: d.unique_name, x: d.x, y: d.y });
                });
                HistoricContext.insert(getKeyFromParams('positions'), nodePositions, 'session');
                HistoricContext.save();

                // Fix nodes in place so they can be dragged, but not moved by force
                nodes.classed('fixed', function(d) { d.fixed = true; });

                // Move nodes into place (after a delay to let forces settle down)
                window.setTimeout(function() {
                    nodes.transition().attr('transform', translate);
                }, 0);
            };

            /* Return CSS property to moves nodes into position */
            var translate = function(d) {
                return 'translate(' + d.x + ',' + d.y + ')';
            };

            /* For a given node, draw lines to all its related nodes */
            var showAllConnections = function(currentNode, persist) {
                currentNode.isActive = true;

                var links = [];
                data.links.filter(function(l) {
                    return l.source === currentNode.unique_name || l.target === currentNode.unique_name;
                }).forEach(function(l) {
                    var src = getRelevantNodes().filter(function(n) { return n.unique_name === l.source; })[0];
                    var tar = getRelevantNodes().filter(function(n) { return n.unique_name === l.target; })[0];

                    if (src && tar) {
                        links.push({ source: src, target: tar, direct: true });

                        src.isActive = true;
                        tar.isActive = true;
                    }
                });

                // Create links for the shortest path(s) from the node to the central node
                if (!scope.isCentralNode(currentNode)) {
                    currentNode.path_to_center.forEach(function(p) {
                        var linksToAdd = [];
                        var invalid = false;
                        p.forEach(function(l) {
                            var src = getRelevantNodes().filter(function(n) { return n.unique_name === l.source; })[0];
                            var tar = getRelevantNodes().filter(function(n) { return n.unique_name === l.target; })[0];

                            if (src && tar) {
                                linksToAdd.push({ source: src, target: tar, direct: false });
                            } else {
                                invalid = true;
                            }
                        });

                        if (!invalid) {
                            links = links.concat(linksToAdd);
                        }
                    });
                }

                // Draw the lines to visualise links
                var lines = linkGroup.selectAll('.' + currentNode.unique_name)
                    .data(links)
                    .enter()
                    .append('line')
                    .attr('class', currentNode.type)
                    .classed(currentNode.unique_name, persist)
                    .classed('hover', !persist)
                    .classed('direct', function(l) { return l.direct; });

                // Move lines into position, with a delay if the trendscape isn't finished drawing yet
                window.setTimeout(function() {
                    lines.attr('x1', function(d) { return d.source.x; })
                        .attr('y1', function(d) { return d.source.y; })
                        .attr('x2', function(d) { return d.target.x; })
                        .attr('y2', function(d) { return d.target.y; });
                }, loaded ? 0 : 250);
            };


            /** Data manipulation **/

            /* Hide/remove irrelevant nodes */
            var updateData = function() {
                loadFilters();

                data.nodes.forEach(function(d) {
                    if (!scope.isCentralNode(d)) {
                        /* Only show 'additional' nodes if only one of [trend, observation] is selected.
                           i.e. additional trends will show if observations are deselected, and vice versa.
                           These nodes will not exist at all within the diagram */
                        if (scope.selectedFilters.trend && scope.selectedFilters.observation && d.additional) {
                            d.removed = true;
                        }

                        // Hide "least common" nodes if "most common" is selected, and vice versa
                        else if ((isHvt(d) || d.type === 'pillar') && d.category !== scope.mostCommon) {
                            d.removed = true;
                        }

                        // Remove nodes that are of a type that the user has disabled
                        else if (!scope.selectedFilters[d.type]) {
                            d.removed = true;
                        }

                        // Remove "hidden" nodes
                        else if (d.hidden) {
                            d.removed = true;
                        }

                        // Show other nodes
                        else {
                            d.removed = false;
                        }
                    }
                });

                /* Only show the three most relevant HVT nodes which are of a type that is still enabled. Note that
                   if types of HVT are disabled by the user, extra HVTs (of enabled types) will be added, so there
                   will always be three HVT nodes unless all HVT types have been disabled by the user. */
                var hvts = [[],[],[]];
                ['demographic', 'sector', 'driver'].forEach(function(h) {
                    if (scope.selectedFilters[h]) {
                        var nodes = data.nodes.filter(function(d) {
                            return d.type === h && d.category === scope.mostCommon;
                        });
                        nodes = _.sortBy(nodes, function(d) { return d.order; });
                        if (nodes) {
                            hvts[0].push(nodes[0]);
                            hvts[1].push(nodes[1]);
                            hvts[2].push(nodes[2]);
                        }
                    }
                });

                // Create a list of HVT nodes to show in order of relevance
                var orderedHvts = [];
                hvts.forEach(function(h) {
                    h = _.sortBy(h, 'order');
                    h.forEach(function(d) {
                        orderedHvts.push(d);
                    });
                });

                // Remove all but the three most relevant nodes
                var nodesToShow = [ orderedHvts[0], orderedHvts[1], orderedHvts[2] ];
                data.nodes.filter(function(d) {
                    return !scope.isCentralNode(d) && isHvt(d) && nodesToShow.indexOf(d) === -1;
                }).forEach(function(d) {
                    d.removed = true;
                });
            };

            /* Return all relevant nodes */
            var getRelevantNodes = function() {
                return data.nodes.filter(function(d) { return !d.removed; });
            };

            /* Return whether a given item is an HVT */
            var isHvt = function(item) {
                return item.type === 'driver' || item.type === 'demographic' || item.type === 'sector';
            };


            /** Event Handlers **/

            /* Handler for mouse entering a node */
            var mouseover = function(d) {
                // Bring node to the front
                d3.select(this).moveToFront();

                // Make the circle bigger to indicate mouseover
                var node = d3.select(this);
                var circle = node.select('circle');
                circle.transition().attr('r', d.radius + 10);

                // Draw all connections to/from the node
                showAllConnections(d, false);

                // Blur out irrelevant nodes
                nodes.transition()
                    .style('opacity', function(d) { return d.isActive ? 1 : 0.5; })
                    .style('filter', function(d) { return d.isActive ? '' : 'url("#desaturate")'; });
            };

            /* Handler for mouse exiting a node */
            var mouseout = function(d) {
                // Make the circle smaller again to indicate mouseout
                var node = d3.select(this);
                var circle = node.select('circle');
                circle.transition().attr('r', d.radius);

                // Remove extra links shown for node that was being hovered over
                d3.selectAll('line.hover').remove();

                // Unblur the irrelevant nodes
                data.nodes.forEach(function(d) {
                    d.isActive = false;
                });
                //nodes.style('filter', '');
                nodes.transition().style('opacity', 1).style('filter','');
            };

            /* Handler for clicking on a node */
            var nodeclick = function(d) {
                // If node is being dragged, suppress click behaviour
                if (d3.event.defaultPrevented) {
                    return;
                }

                // If node is central search node and there are no search filters, suppress click behaviour
                if (d.type === 'search_keyword' && !searchFilters) {
                    return;
                }

                if (!tooltipOpen ||  (tooltipOpen && tooltipId !== d.unique_name)) {
                    // Show the tooltip
                    scope.$apply(function() {
                        scope.mouseOverNode = true;
                    });

                    var node = d3.select(this);
                    var coord = d3.transform(node.attr('transform')).translate;
                    if (coord[1] >= 300) {
                        tooltip.direction('n');
                        tooltip.offset([-170, -120]);
                    }
                    else {
                        tooltip.direction('s');
                        tooltip.offset([0, -120]);
                    }

                    tooltip.show(node.data(), node.node());

                    tooltipOpen = true;
                    tooltipId = d.unique_name;
                    selectedNode = this;

                    // Compile the tooltip template
                    var element = angular.element($('#trendscape-hover-container'));
                    var myscope = element.scope();
                    myscope.data = d;
                    $compile(element)(scope);
                } else {
                    tooltip.hide();
                    tooltipOpen = false;
                }
            };

            /* Handler for right-clicking on a node */
            var rightclick = function(d) {
                // Suppress default right click behaviour
                if (d3.event) {
                    d3.event.preventDefault();
                }

                // Freeze/unfreeze the node in place
                d.frozen = !d.frozen;
                if (d.frozen) {
                    if (!_.contains(frozenNodes), d.unique_name) {
                        frozenNodes.push(d.unique_name);
                    }

                    nodes.filter(function(n) {
                        return n.unique_name === d.unique_name;
                    }).on('mousedown.drag', null);

                    showAllConnections(d, true);
                } else {
                    frozenNodes = frozenNodes.filter(function(n) {
                        return n !== d.unique_name;
                    });

                    d3.selectAll('.' + d.unique_name).remove();
                    d3.select(this).call(drag);

                    // Redraw hover lines
                    showAllConnections(d, false);
                }

                saveFilters();
            };


            /** Scope functions/watches **/

            /* Hide and remove tooltip when clicking a 'go to x' button on a trend/obs tooltip */
            scope.hideTooltip = function() {
                tooltip.hide();
                $('.d3-tip').remove();
            };

            /* Hide tooltip when click somewhere that is not a node or the sidebar */
            $(document).mouseup(function (e) {
                if (e.target.tagName !== 'circle' && e.target.tagName !== 'HTML'){
                    tooltip.hide();
                    tooltipOpen = false;
                }
            });

            /* Function to get shareable URL */
            scope.getShareUrl = function() {
                return location.href;
            };

            /* Centre the selected node and load related data for it. Called from node tooltip focus button */
            scope.refocus = function(d) {
                scope.dataReady = false;
                mode = 'item';
                itemId = d.id;
                nextCentreNode = selectedNode;
                nodeClicked = true;
                itemType = (d.type === 'driver' || d.type === 'demographic' || d.type === 'sector') ?
                    'hvt' : d.type;

                Api.trendscape[itemType].get({ 'id': d.id }).then(dataLoaded, dataNotLoaded);
                document.title = 'Trendscape - ' + d.title;
            };

            /* Check if the given node is the centre focus */
            scope.isCentralNode = function(d) {
                return d.relevance === 0 || d.unique_name === itemName;
            };

            /* invoked by the pptbuilder to resize the svg to the appropriate size for storage */
            scope.redraw = function(w, h) {
                if (w && h) {
                    // Resize with viewbox containing all elements of svg
                    var bbox = svg[0][0].getBBox();
                    var padding = 5;
                    var viewbox = [
                        bbox.x - padding,
                        bbox.y - padding,
                        bbox.width + (2 * padding),
                        bbox.height + (2 * padding)
                    ];

                    svg.attr('viewBox', _(viewbox).join(' '))
                       .attr('width', w)
                       .attr('height', h)
                       .attr('preserveAspectRatio', 'xMidYMid meet');
                }
                else {
                    // Reset viewbox, etc to original
                    svg.attr('viewBox', null)
                       .attr('width', width)
                       .attr('height', height)
                       .attr('preserveAspectRatio', null);
                }

            };

            /* used for auto starting the trendscape tour */
            scope.loaded = function() {
                return loaded;
            };

            /* Update data when an item type is selected or deselected by the user */
            scope.toggleFilter = function(filter) {
                // If both Trend and Observation are de-selected, re-select whichever was first de-selected
                if (!scope.selectedFilters.trend && !scope.selectedFilters.observation) {
                    scope.selectedFilters[filter === 'trend' ? 'observation' : 'trend'] = true;
                }

                saveFilters();
                updateData();
                updateDisplay();
            };

            /* Update data to hide/show least/most connected HVTs based on user selection */
            scope.setMostCommon = function(value) {
                scope.mostCommon = value;
                saveFilters();
                updateData();
                updateDisplay();
            };

            /* Remove node from view */
            scope.removeNode = function(d) {
                if (!scope.isCentralNode(d)) {
                    var node = _.find(data.nodes, function(n) { return n.unique_name === d.unique_name; });
                    node.hidden = true;
                    updateData();
                    updateDisplay();

                    // Remove any remaining lines connected to the removed node
                    d3.selectAll('.' + d.unique_name).remove();
                }
            };

            /* Completely reset all changes made by the user to the Trendscape */
            scope.resetTrendscape = function() {
                // Re-check all the filters
                for (var f in scope.selectedFilters) {
                    scope.selectedFilters[f] = true;
                }

                // Reset pillar connections option
                scope.mostCommon = 'most_common';

                // Add back any removed nodes and reset all node positions
                frozenNodes = [];
                data.nodes.forEach(function(d) {
                    d.removed = false;
                    d.hidden = false;
                    d.frozen = false;

                    d.x = width/2;
                    d.px = width/2;
                    d.y = height/2;
                    d.py = height/2;
                });

                // Save filter changes in session storage
                saveFilters();

                // Remove saved node positions
                HistoricContext.insert(getKeyFromParams('positions'), null, 'session');
                HistoricContext.save();

                // Remove any lines from frozen nodes
                d3.selectAll('line').remove();

                // Redraw the trendscape
                updateData();
                updateDisplay();
            };

            /* Resize the SVG when the window resizes */
            $(window).on('resize.trendscape', function() {
                if (loaded) {
                    width = $(window).width() - 250;
                    svg.attr('width', width);
                    updateDisplay();
                }
            });


            /** D3 functions **/

            /* Prototype method to move a node to the front by moving it to the end of the SVG element */
            d3.selection.prototype.moveToFront = function() {
                return this.each(function() {
                    var d = d3.select(this).data()[0];
                    var nodes = d3.select('#nodes').selectAll('g');
                    nodes.sort(function(a, b) {
                        if (a.unique_name === d.unique_name) {
                            return 1;
                        } else if (b.unique_name === d.unique_name) {
                            return -1;
                        } else {
                            return 0;
                        }
                    });

                });
            };


            /** Misc functions **/

            /* Hide the tooltip and remove window resize handler if the user navigates to another page */
            scope.$on('$stateChangeStart', function() {
                if (tooltipOpen) {
                    tooltip.hide();
                }

                $(window).off('resize.trendscape');
            });

            /* Create a unique name with the current trendscape parameters to use as a key for session storage */
            var getKeyFromParams = function(type) {
                var key = 'trendscape_';

                if (mode === 'item') {
                    key += 'item_' + itemName;
                } else if (mode === 'search') {
                    key += 'search_' + searchTerm + '_' + JSON.stringify(searchFilters);
                }

                return key + '_' + type;
            };

            /* Load saved filters from session storage */
            var loadFilters = function() {
                scope.selectedFilters = HistoricContext.get().session[getKeyFromParams('filters')] ||
                    scope.selectedFilters || {
                        'trend': true,
                        'observation': true,
                        'pillar': true,
                        'driver': true,
                        'demographic': true,
                        'sector': true,
                        'search': true,
                    };

                scope.mostCommon = HistoricContext.get().session[getKeyFromParams('common')] || 'most_common';

                frozenNodes = HistoricContext.get().session[getKeyFromParams('frozen')] || [];
            };

            /* Save updated filters to session storage */
            var saveFilters = function() {
                HistoricContext.insert(getKeyFromParams('filters'), scope.selectedFilters, 'session');
                HistoricContext.insert(getKeyFromParams('common'), scope.mostCommon, 'session');
                HistoricContext.insert(getKeyFromParams('frozen'), frozenNodes, 'session');

                HistoricContext.save();
            };
        }
    };
}]);
